module.exports = __webpack_public_path__ + "media/tick2.b0232439.webm";